import styled from 'styled-components'
import { IRoute } from '../bills/BillsPage'
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import React, { useEffect, useMemo, useState } from 'react'
import { PageContainer } from '../../components/Layout/PageContainer'
import { TabBar } from '../../components/TabBar/TabBar'
import { FadePresence } from '../../components/FadePresence'
import { Body, Button, colors, Dialog, Spacer } from '@spritz-finance/ui'
import { Feature, useFeatureFlag } from '../../context/useFeatureFlag'
import { PageTitle } from '../../components/PageTitle'
import { RewardsSubPage } from './RewardsSubPage'
import ReferralsSubPage from './ReferralsSubPage'
import { Row } from '../../components/Layout/Row'
import { ItemWrapper } from './item'
import { cssVar } from '../../theme/utils'

export const Wrapper = styled.div``

const routes: IRoute[] = [
    {
        text: 'Referrals',
        path: 'main',
    },
    {
        text: 'Rewards',
        path: 'rewards',
    },
]

export default function ReferralsProgramPage() {
    const navigate = useNavigate()
    const location = useLocation()
    const { pathname } = useLocation()
    const subRoute = pathname.split('/')[2]

    const [termsOpen, setTermsOpen] = useState(false)

    useEffect(() => {
        if (!subRoute) {
            navigate(routes[0].path)
            return
        }
    }, [pathname, subRoute])

    return (
        <PageContainer>
            <PageTitle>This one's on us! 🍹 Give $50, Get $50</PageTitle>

            <TabBar routes={routes} subRoute={subRoute} />
            <Spacer height={24} />
            <Wrapper>
                <FadePresence renderKey={location.pathname}>
                    <Routes location={location}>
                        <Route path="rewards" element={<RewardsSubPage />} />
                        <Route path="main" element={<ReferralsSubPage />} />
                    </Routes>
                </FadePresence>
            </Wrapper>

            <Spacer height={32} />

            <Button.Text
                style={{ color: cssVar('--text-secondary', colors.black) }}
                onClick={() => setTermsOpen(true)}
            >
                Terms
            </Button.Text>

            <Dialog open={termsOpen} onClose={() => setTermsOpen(false)}>
                <Dialog.Content>
                    <Spacer height={64} />
                    <Row align="center">
                        <Body.Med size={18} align="center">
                            The fine print
                        </Body.Med>
                    </Row>
                    <Spacer height={16} />
                    <ItemWrapper>
                        In order to qualify for reward, referee must sign up via your referral link.
                        No exceptions.
                    </ItemWrapper>
                    <ItemWrapper>
                        Referee must pass Spritz KYC account verification in order to pay their
                        first bill(s).
                    </ItemWrapper>
                    <ItemWrapper>
                        Qualified bill payment(s) must equal or be greater than $50 in order to earn
                        rewards.
                    </ItemWrapper>
                    <ItemWrapper>
                        Rewards will be distributed to you and your referred users' Spritz accounts
                        within 30 days once the qualifying bill payments are confirmed and finalized
                        by your referred users' bill-pay accounts.
                    </ItemWrapper>
                    <ItemWrapper>
                        Maximum monthly referrer rewards are capped at $5,000, or 100 qualified bill
                        pay user referrals each month.
                    </ItemWrapper>
                    <ItemWrapper>
                        You’ll be notified via email each time you have qualified for a referral
                        reward based on when your referred friend successfully funds their
                        qualifying $50 bill payment.
                    </ItemWrapper>
                </Dialog.Content>
            </Dialog>
        </PageContainer>
    )
}
